import {
  SET_SOHO_CUSTOMER_INFO,
  FAILED_SET_SOHO_CUSTOMER_INFO,
  SET_SOHO_SERVICES
} from './actionsTypes'

const initialState = {
  sohoCustomerInfo: {},
  fixedLineSOHOServices: {}
}
const fixedLineSOHOCustomerInfoData = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SET_SOHO_CUSTOMER_INFO:
      return {
        ...state,
        sohoCustomerInfo: payload,
        errorMsg: null,
      }

    case FAILED_SET_SOHO_CUSTOMER_INFO:
      return {
        ...state,
        errorMsg: payload,
      }

      case SET_SOHO_SERVICES:
        return {
          ...state,
          fixedLineSOHOServices: payload,
        }

    default:
      return state
  }
}

export default fixedLineSOHOCustomerInfoData
